import { useRef, useState } from "react";
import { Box, Icon, css } from "@storyofams/react-ui";
import ReactPlayer from "react-player/lazy";
import { PlayButton } from "~components/common/Icons";
import { VideoModal } from "../components/VideoModal";

export const Video = ({ content, ...props }) => {
  const wrapperRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const player = useRef();

  const onChangeModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box
      width="100%"
      mx="auto"
      height="100%"
      display="flex"
      ref={wrapperRef}
      {...props}
    >
      {props?.text_align ? (
        <Box
          borderRadius={"md"}
          mx="auto"
          display="flex"
          justifyContent="center"
          bg="grey200"
          css={css({
            position: "relative",
            width: "100%",
            pt: "56.25%",
            "> div": {
              position: "absolute",
              left: 0,
              top: 0,
              width: "100% !important",
              height: "100% !important",
            },
            iframe: {
              borderRadius: "md",
              width: "100%",
              height: "100%",
            },
          })}
        >
          <ReactPlayer
            ref={player}
            url={content?.url}
            controls
            playing={false}
            width={"100%"}
            height={"100%"}
            config={{
              youtube: {
                playerVars: {
                  modestbranding: 1,
                  controls: true,
                },
              },
            }}
          />
        </Box>
      ) : (
        <Box
          borderRadius={"md"}
          mx="auto"
          display="flex"
          justifyContent="center"
          bg="grey200"
          css={css({
            video: {
              objectFit: "cover",
              borderRadius: "md",
            },
            position: "relative",
            width: "100%",
            pt: "56.25%",
            "> div": {
              position: "absolute",
              left: 0,
              top: 0,
              width: "100% !important",
              height: "100% !important",
            },
            iframe: {
              borderRadius: "md",
              width: "100%",
              height: "100%",
            },
          })}
        >
          {content?.url && (
            <Box
              position={"relative"}
              onClick={onChangeModal}
              cursor={"pointer"}
            >
              <ReactPlayer
                ref={player}
                url={content?.url}
                controls
                playing={false}
                config={{
                  youtube: {
                    playerVars: {
                      modestbranding: 1,
                      controls: true,
                    },
                  },
                }}
                width={"100%"}
                height={"100%"}
              />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};
